import { useEffect, type ReactNode } from 'react'

/** A composer dialog in OnlyFans' style (uppercase title, actions bottom right); Esc or the backdrop closes. */
export function Dialog({ title, onClose, children, actions, wide = false, head }: { title: string; onClose: () => void; children: ReactNode; actions?: ReactNode; wide?: boolean; head?: ReactNode }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose()
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])
  return (
    <div className="ofp-modal-back" onClick={onClose}>
      <div className={`ofp-modal ${wide ? 'ofp-modal--wide ofh-modal--wide' : ''}`} role="dialog" aria-modal="true" aria-label={title} onClick={(e) => e.stopPropagation()}>
        <div className="ofp-modal-head">
          <h3 className="ofp-modal-title">{title}</h3>
          {head}
        </div>
        {children}
        {actions && <div className="ofp-modal-actions">{actions}</div>}
      </div>
    </div>
  )
}
